var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "video-container" },
    [
      _c("div", { staticClass: "oper-group" }, [
        _vm.editModeX
          ? _c("i", {
              staticClass: "icon iconfont icon-eye",
              attrs: { title: "预览视频效果" },
              on: {
                click: function($event) {
                  _vm.switchEditMode()
                }
              }
            })
          : _c("i", {
              staticClass: "icon iconfont icon-editor",
              attrs: { title: "设置视频信息" },
              on: {
                click: function($event) {
                  _vm.switchEditMode()
                }
              }
            })
      ]),
      _vm._v(" "),
      _vm.editModeX
        ? _c(
            "div",
            {
              staticClass: "video-editor",
              style: { width: _vm.width + "px", height: _vm.height + "px" }
            },
            [
              _c("div", { staticClass: "form-info" }, [
                _c("div", { staticClass: "form-row video" }, [
                  _c("div", { staticClass: "form-label" }, [
                    _c("label", [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.flashFlagX,
                            expression: "flashFlagX"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(_vm.flashFlagX)
                            ? _vm._i(_vm.flashFlagX, null) > -1
                            : _vm.flashFlagX
                        },
                        on: {
                          change: function($event) {
                            var $$a = _vm.flashFlagX,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 && (_vm.flashFlagX = $$a.concat([$$v]))
                              } else {
                                $$i > -1 &&
                                  (_vm.flashFlagX = $$a
                                    .slice(0, $$i)
                                    .concat($$a.slice($$i + 1)))
                              }
                            } else {
                              _vm.flashFlagX = $$c
                            }
                          }
                        }
                      }),
                      _c("span", [_vm._v("Flash格式视频")])
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row video" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.urlX,
                          expression: "urlX"
                        }
                      ],
                      attrs: { type: "text", placeholder: "URL" },
                      domProps: { value: _vm.urlX },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.urlX = $event.target.value
                        }
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row video" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-label",
                      staticStyle: { width: "auto" }
                    },
                    [
                      _c("label", [
                        _vm._v("宽"),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.widthX,
                              expression: "widthX"
                            }
                          ],
                          staticClass: "ml5",
                          staticStyle: { width: "60px" },
                          attrs: { type: "number", placeholder: "宽" },
                          domProps: { value: _vm.widthX },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.widthX = $event.target.value
                            }
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("×")]),
                      _vm._v(" "),
                      _c("label", [
                        _vm._v("高"),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.heightX,
                              expression: "heightX"
                            }
                          ],
                          staticClass: "ml5",
                          staticStyle: { width: "60px" },
                          attrs: { type: "number", placeholder: "高" },
                          domProps: { value: _vm.heightX },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.heightX = $event.target.value
                            }
                          }
                        })
                      ])
                    ]
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row video" }, [
                  _vm._m(1),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-value" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.posterX,
                          expression: "posterX"
                        }
                      ],
                      attrs: { type: "text", placeholder: "URL" },
                      domProps: { value: _vm.posterX },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.posterX = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              ])
            ]
          )
        : _c("swb-video-player", {
            attrs: {
              flashFlag: _vm.flashFlagX,
              url: _vm.urlX,
              width: _vm.widthX,
              height: _vm.heightX,
              poster: _vm.posterX,
              allowFullScreen: _vm.allowFullScreenX
            }
          })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("视频URL")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("海报图片")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a2bab4e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a2bab4e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ctrl/VideoEditor.vue
// module id = 4640
// module chunks = 0